// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"0ffa0377","854":"d5fcc7d7","903":"15b81f5d"}[chunkId] + ".chunk.js";
};